import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  ErrorPage,
  MainPage,
  SignInPage,
  SignUpPage,
  ProductPage,
  DashboardPage,
  PaymentPage,
  ThreadPage,
  AspectsPage,
  APIConnectPage,
  CSVPage,
} from "components/pages";
import { Auth } from "components/template/Auth";
import { ToastWrapper as Toast } from "components/template/Toast";
import { Modals } from "components/modals";

const App = () => (
  <BrowserRouter>
    <Toast />
    <Modals />
    <Routes>
      <Route path={"/sign-in"} element={<SignInPage />} />
      <Route path={"/sign-up"} element={<SignUpPage />} />
      <Route path={"/payment"} element={<PaymentPage />} />
      <Route path={"/"} element={<Auth />}>
        <Route path={"/"} element={<MainPage />} />
        <Route path={"/payment"} element={<PaymentPage />} />
        <Route path={"/:projectName"} element={<DashboardPage />} />
        <Route path={"/:projectName/thread"} element={<ThreadPage />} />
        <Route path={"/:projectName/aspects"} element={<AspectsPage />} />
        <Route path={"/:projectName/demo"} element={<ProductPage />} />
        <Route path={"/:projectName/batch"} element={<ProductPage />} />
        <Route path={"/:projectName/api-connect"} element={<ProductPage />} />
        <Route path={"/:projectName/connect"} element={<APIConnectPage />} />
        <Route path={"/:projectName/csv"} element={<CSVPage />} />
      </Route>

      <Route path={"*"} element={<ErrorPage />} />
    </Routes>
  </BrowserRouter>
);

export default App;
